// extracted by mini-css-extract-plugin
export default {"onboarding-modal":"components-settings-currency-conversion-modals-onboarding-module__onboarding-modal"};